const constants = {
    title: 'Sunny Feeders',
    entityName: 'Sunny Feeders',
};
export { constants };
